import { render, staticRenderFns } from "./ExtraInformation.vue?vue&type=template&id=9e1f18c0&scoped=true"
import script from "./ExtraInformation.vue?vue&type=script&lang=js"
export * from "./ExtraInformation.vue?vue&type=script&lang=js"
import style0 from "./ExtraInformation.vue?vue&type=style&index=0&id=9e1f18c0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e1f18c0",
  null
  
)

export default component.exports